export var EmployeeStatus;
(function (EmployeeStatus) {
    EmployeeStatus["ACTIVE"] = "ACTIVE";
    EmployeeStatus["ON_LEAVE"] = "ON_LEAVE";
    EmployeeStatus["NOTICE_PERIOD"] = "NOTICE_PERIOD";
    EmployeeStatus["TERMINATED"] = "TERMINATED";
    EmployeeStatus["CONTRACTOR"] = "CONTRACTOR";
    EmployeeStatus["INTERN"] = "INTERN";
})(EmployeeStatus || (EmployeeStatus = {}));
export var EmployeeType;
(function (EmployeeType) {
    EmployeeType["FULL_TIME"] = "FULL_TIME";
    EmployeeType["PART_TIME"] = "PART_TIME";
    EmployeeType["CONTRACTOR"] = "CONTRACTOR";
    EmployeeType["INTERN"] = "INTERN";
})(EmployeeType || (EmployeeType = {}));
export var WorkLocation;
(function (WorkLocation) {
    WorkLocation["BANGALORE"] = "BANGALORE";
    WorkLocation["MUMBAI"] = "MUMBAI";
    WorkLocation["INDIA_REMOTE"] = "INDIA_REMOTE";
    WorkLocation["USA_HQ"] = "USA_HQ";
    WorkLocation["USA_REMOTE"] = "USA_REMOTE";
})(WorkLocation || (WorkLocation = {}));
//# sourceMappingURL=employee.js.map